import { render, staticRenderFns } from "./EProgressoPreenchimento.vue?vue&type=template&id=5fa8ceb4&scoped=true"
import script from "./EProgressoPreenchimento.vue?vue&type=script&lang=js"
export * from "./EProgressoPreenchimento.vue?vue&type=script&lang=js"
import style0 from "./EProgressoPreenchimento.vue?vue&type=style&index=0&id=5fa8ceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8ceb4",
  null
  
)

export default component.exports